// @flow
import * as React from 'react';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR__16} from '@homeaway/svg-defs';
import type {FlexibleDatesDesktopMobileProps} from './FlexibleDates';

import {GENERIC_EVENT} from '../../utils/edapWrapper';

import FlexibleDatesOption from './FlexibleDatesOption';

import './FlexibleDatesMobile.less';

export default function FlexibleDatesMobile({
    title,
    options,
    ...props
}: FlexibleDatesDesktopMobileProps) {
    function renderOptions(type, _options) {
        return _options.map((optionProps) => (
            <DropdownItem
                key={optionProps.id}
                text={
                    <div className="FlexibleDatesMobile__Item">
                        <FlexibleDatesOption
                            type={type}
                            {...props}
                            {...optionProps}
                        />
                    </div>
                }
            />
        ));
    }

    // $FlowFixMe
    const trackingContext = React.useContext(TrackingContext);

    function onDropdownShow() {
        trackingContext.trigger(GENERIC_EVENT, {
            eventaction: 'dropdown opened'
        });
    }

    return (
        <div className="FlexibleDatesMobile">
            <Dropdown
                id="flexible-dates"
                onDropdownShow={onDropdownShow}
                label={
                    <>
                        <SVGIcon markup={CALENDAR__16} inline aria-hidden />
                        <span className="FlexibleDatesMobile__Label">
                            {title}
                        </span>
                    </>
                }
            >
                {options.sub && renderOptions('sub', options.sub)}
                {options.add && renderOptions('add', options.add)}
            </Dropdown>
        </div>
    );
}
